// src/routing/AppRoutes.js
import { Routes, Route, Navigate } from 'react-router-dom';
import { useContext, useMemo } from 'react';
import { AuthContext } from 'context/AuthContext';
import ProtectedRoute from './routing/ProtectedRoute';
import routes from './routes';
import SignInCover from 'layouts/authentication/sign-in/cover';

// Aplana recursivamente el árbol de routes y devuelve solo nodos con route+component
function flattenRoutes(nodes = []) {
  const out = [];
  nodes.forEach((n) => {
    if (n.route && n.component) out.push(n);
    if (Array.isArray(n.collapse)) out.push(...flattenRoutes(n.collapse));
  });
  return out;
}

// Normaliza paths para React Router (sin slash inicial)
function normalizePath(p) {
  if (!p) return '';
  return p.startsWith('/') ? p.slice(1) : p;
}

export default function AppRoutes() {
  const { isAuthenticated } = useContext(AuthContext);

  const flat = useMemo(() => flattenRoutes(routes), []);
  const protectedRoutes = flat.filter((r) => r.protected);
  const publicRoutes = flat.filter((r) => !r.protected);

  // Ruta “home” por defecto al estar autenticado (usa la primera protegida disponible).
  // Si no hubiera, cae a login.
  const authedHome = protectedRoutes.length ? protectedRoutes[0].route : '/login';
  const fallbackTarget = isAuthenticated ? authedHome : '/login';

  return (
    <Routes>
      {/* Ruta pública de login explícita */}
      <Route path="/login" element={<SignInCover />} />

      {/* Otras rutas públicas definidas en routes (si tuvieras más) */}
      {publicRoutes.map((r) => (
        <Route key={r.route} path={normalizePath(r.route)} element={r.component} />
      ))}

      {/* Bloque protegido */}
      <Route element={<ProtectedRoute />}>
        {protectedRoutes.map((r) => (
          <Route key={r.route} path={normalizePath(r.route)} element={r.component} />
        ))}
      </Route>

      {/* Fallbacks */}
      <Route path="/" element={<Navigate to={fallbackTarget} replace />} />
      <Route path="*" element={<Navigate to={fallbackTarget} replace />} />
    </Routes>
  );
}
